module.exports = __webpack_public_path__ + "static/media/SmartManufacturingObjectives_CIMG.87da3c1d.png";